import {API} from "../../../backend";
import { objectToQueryString } from "../../../lib/utils";

export const createGymEnquiry=(userId,token,body)=>{
    return fetch(`${API}/create/gym-equiry/${userId}`,{
        method: "POST",
        headers:{
            Accept: "application/json",
            'Content-type':"application/json",
            Authorization:`Bearer ${token}`
        },
        body:JSON.stringify(body)
    })
    .then(response => {
        return response.json();
    })
    .catch(err => { console.error(err); return { error: true, message: err?.message }; })
}

export const updateGymEnquiry=(userId,token,enquiryId,body)=>{
    return fetch(`${API}/update/gym-enquiry/${userId}/${enquiryId}`,{
        method: "PUT",
        headers:{
            Accept: "application/json",
            'Content-type':"application/json",
            Authorization:`Bearer ${token}`
        },
        body:JSON.stringify(body)
    })
    .then(response => {
        return response.json();
    })
    .catch(err => { console.error(err); return { error: true, message: err?.message }; })
}

export const closeEnquiry = (userId,token,enquiryId,body)=>{
    return fetch(`${API}/close-enquiry/${userId}/${enquiryId}`,{
        method: "POST",
        headers:{
            Accept: "application/json",
            'Content-type':"application/json",
            Authorization:`Bearer ${token}`
        },
        body:JSON.stringify(body)
    })
    .then(response => {
        return response.json();
    })
    .catch(err => {
        console.log(err);
        return { error: true, message: err?.message || "Network error" };
    });
}

export const getGroupedEnquiryCount = (userId, token,query) => {
    let str=objectToQueryString(query);
    return fetch(`${API}/enquiries/group-count/${userId}?${str}`, {
        method: 'GET',
        headers: {
            "Accept": "application/json",
            Authorization: `Bearer ${token}`
        }
    }).then(response => {
        return response.json();
    }).catch(err => { console.error(err); return { error: true, message: err?.message }; })
};

export const getEnquiryByID = (userId, token, enquiryId) => {
    return fetch(`${API}/enquiry/${userId}/${enquiryId}`,{
        method: "GET",
        headers:{
          Accept: "application/json",
          Authorization: `Bearer ${token}`
      },
    })
    .then(response => {
        return response.json();
    })
    .catch(err => { console.error(err); return { error: true, message: err?.message }; })
};


export const bulkUploadEnquiries=(userId,token,branchId,body)=>{
    return fetch(`${API}/bulk-enquiry-upload/${userId}/${branchId}`,{
        method:'POST',
        headers:{
            Accept:"application/json",
            Authorization:`Bearer ${token}`
        },
        body:body
    }).then(response=>{
        return response.json();
    }).catch(err => { console.error(err); return { error: true, message: err?.message }; })
};

export const downloadEnquiryAsExcel = (userId,token,query)=>{
    let str=objectToQueryString(query);
    return fetch(`${API}/download-enquiry/${userId}?${str}`,{
        method:'GET',
        headers:{
            Authorization:`Bearer ${token}`
        }
    }).then(response=>response.blob()).catch(err => { console.error(err); return { error: true, message: err?.message }; })
};